<template>
  <button class="button filled accent-1 download" @click.prevent="exportToPDF">
    Download PDF
  </button>
  <div class="pdf-content-wrapper">
    <div id="pdf-content" v-html="pdfContent"></div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  props:      {
    sentences: {
      type: Array
    },
    reflectionPrompts: {
      type: Array
    },
    selfReflection: {
      type: String
    }
  },
  data() {
    return {
      pdfContent:     "",
    };
  },
  mounted() {
    // console.log(this.sentences);
  },
  computed: {},
  methods:  {
    exportToPDF() {
      this.pdfContent += "<p style='font-weight: 800; margin-bottom: 0px; padding: 0; text-align: center; font-size: 18px;'>Sentence Completion - Self-Awareness Exercise</p>";

      for (let i = 0; i < this.sentences.length; i++) {
        this.pdfContent += "<p style='margin: 0'><span style='font-weight: 600;'>" + (i + 1) + ") </span>" + this.sentences[i].value + "</p>";
      }

      this.pdfContent += "<p style='font-weight: 800; margin: 10px 0 0'>Reflection Prompts</p>";
      for (let i = 0; i < this.reflectionPrompts.length; i++) {
        this.pdfContent += "<p style='margin: 0'><span style='font-weight: 600;'>" + (i + 1) + ") </span>" + this.reflectionPrompts[i] + "</p>";
      }

      if (this.selfReflection) {
        this.pdfContent += "<p style='font-weight: 800; margin: 10px 0 0'>Reflection Notes</p>";
        this.pdfContent += "<p>" + this.selfReflection + "</p>";
      }

      this.pdfContent += "<p>&nbsp;</p>";
      this.pdfContent += "<hr style='margin: 0'>";
      this.pdfContent += "<p style='text-align: center;'>&copy; Greg Harris Coaching. www.gregharriscoaching.com</p>";
      this.pdfContent += "<hr style='margin: 0'>";
      this.pdfContent += "<p>&nbsp;</p>";


      setTimeout(function () {
        let pdfContentEl = document.getElementById("pdf-content");
        console.log(pdfContentEl);
        html2pdf(document.getElementById("pdf-content"), {
          margin:      [.5, 1, .5, 1],
          autoPaging:  'text',
          filename:    "sentence-completion.pdf",
          html2canvas: {
            allowTaint:      true,
            letterRendering: true,
            logging:         false,
            scale:           1,
          },
          jsPDF:       {unit: 'in', format: 'A4', orientation: 'portrait'}
        });
      }, 20);

    },
  }
}
</script>
